import Vue from 'vue'
import sa from 'sa-sdk-javascript'
Vue.mixin({
  data() {
    return {
      startTime: 0
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.startTime = new Date()
    })
  },
  beforeRouteLeave(to, from, next) {
    var url = location.origin + '/shop'  + from.fullPath,
      end = new Date()
    // 如果用户一直不关闭页面，可能出现超大值，可以根据业务需要处理，例如设置一个上限
    var duration = (end.getTime() - this.startTime.getTime()) / 1000,
      stayTime = duration > 3600 ? 3600 : duration // 最大停留时长是1h
    // 定义一个记录页面停留时间的事件pageView,并且保存需要的属性(停留时间和当前页面的地址)
    sa.track('_pc_shop_pageclose', {
      pageStayTime: stayTime,
      pageUrl: url
    });
    next()
  },
})